import React from 'react';
import {Row, Col, Button, Form, FormControl, FormGroup, ControlLabel} from 'react-bootstrap';
import {translate} from '../../i18n/translate.js';

class LoginLinkFBAccount extends React.Component {
    state = {
        email: this.props.email,
        password: ''
    };

    handleChangeEmail = (event) => {
        this.setState({email: event.target.value});
    };

    handleChangePassword = (event) => {
        this.setState({password:event.target.value});
    };

    createFBAccountClicked = () => {
        this.props.createFBAccount(this.state.email, this.state.password, this.props.facebookId);
    };

    render() {
        const styleClassEmail = this.props.component === "email" ? "sign-in-email error" : "sign-in-email";
        const styleClassPassword = this.props.component === "password" ? "sign-in-email error" : "sign-in-email";
        return (<div>
            <Form className="message-details">
                <p>{translate('We were unable to recognize your facebook account: ') + this.props.email}</p>
                <p>{translate('To activate Facebook login please enter the email and password you ' +
                    'normally use to access your account')}</p>
            </Form>
            <div className="inner-container inner-container-fb">
                <fieldset className="form-container container-fluid" disabled={this.props.showLoading}>
                    <Row className="sign-in-email-row">
                        <FormControl bsSize="sm" className={styleClassEmail} type="email" value={this.state.email}
                                     placeholder="Email"
                                     onChange={this.handleChangeEmail} ref="email"/>
                        {
                            this.props.component === "email" ?
                                <label className="validation-error">{translate(this.props.status)}</label>
                                : undefined
                        }
                    </Row>
                    <Row className="sign-in-email-row">
                        <FormControl className={styleClassPassword + " _lr-hide"} type="password" value={this.state.password}
                                     placeholder="Password" onChange={this.handleChangePassword} ref="password"/>
                        {
                            this.props.component === "password" ?
                                <label className="validation-error">{translate(this.props.status)}</label>
                                : undefined
                        }
                    </Row>
                    <Row className="sign-in-fb">
                        <Button className="button fb-login-button" onClick={this.createFBAccountClicked}>
                            <div className="btn-fb-text">
                                <div className="fb-img"/>{translate('Create Account with Facebook')}
                            </div>
                        </Button>
                    </Row>
                </fieldset>
            </div>
        </div>);
    }
}

export default LoginLinkFBAccount;


// WEBPACK FOOTER //
// ./src/components/login/LoginLinkFBAccount.js